class RangeSlider extends HTMLElement {
	constructor() {
		super();

		this.minFieldEl = document.getElementById(this.getAttribute('data-min-field'));
		this.maxFieldEl = document.getElementById(this.getAttribute('data-max-field'));

		this.minLabelEl = this.querySelector('.js-range-slider-min-price');
		this.maxLabelEl = this.querySelector('.js-range-slider-max-price');

		this.sliders = this.querySelectorAll('input');
		this.sliders.forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
		this.sliders.forEach(element => element.addEventListener('input', this.onInput.bind(this)));

		this.minPrice = document.querySelectorAll('.js-min-price-input');
		this.maxPrice = document.querySelectorAll('.js-max-price-input');

		this.formatter = new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD'
		});

		this.setRangesFromParams();
	}

	setRangesFromParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const inputMinParam = urlParams.get('range-slider-gte');
		const inputMaxParam = urlParams.get('range-slider-lte');

		if (inputMinParam) {
			const minDesktopRangeEl = document.querySelector('.js-desktop-range-slider-gte');
			const minMobileRangeEl = document.querySelector('.js-mobile-range-slider-gte');
			const minLabels = [...document.querySelectorAll('.js-range-slider-min-price')];

			minDesktopRangeEl.value = parseFloat(inputMinParam);
			minMobileRangeEl.value = parseFloat(inputMinParam);

			minLabels.forEach(minLabel => {
				minLabel.innerHTML = this.formatter.format(parseFloat(inputMinParam));
			});
		}

		if (inputMaxParam) {
			const maxDesktopRangeEl = document.querySelector('.js-desktop-range-slider-lte');
			const maxMobileRangeEl = document.querySelector('.js-mobile-range-slider-lte');
			const maxLabels = [...document.querySelectorAll('.js-range-slider-max-price')];

			maxDesktopRangeEl.value = parseFloat(inputMaxParam);
			maxMobileRangeEl.value = parseFloat(inputMaxParam);

			maxLabels.forEach(maxLabel => {
				maxLabel.innerHTML = this.formatter.format(parseFloat(inputMaxParam));
			});
		}
	}

	setMinAndMaxValues(minValue, maxValue) {
		let minimumValueForMaxInput = 0;
		let maximumValueForMinInput = 0;

		if (maxValue) maximumValueForMinInput = maxValue;
		if (minValue) minimumValueForMaxInput = minValue;
		if (minValue === '') minimumValueForMaxInput = 0;
		if (maxValue === '') maximumValueForMinInput = this.minPrice[0].getAttribute('max');

		this.minPrice.forEach(minPrice => {
			minPrice.setAttribute('max', maximumValueForMinInput);
		});

		this.maxPrice.forEach(maxPrice => {
			maxPrice.setAttribute('min', minimumValueForMaxInput);
		});
	}

	onRangeChange() {
		let slide1 = parseFloat(this.sliders[0].value);
		let slide2 = parseFloat(this.sliders[1].value);

		if (slide1 > slide2) {
			[slide1, slide2] = [slide2, slide1];
		}

		this.minFieldEl.value = slide1;
		this.maxFieldEl.value = slide2;

		this.setMinAndMaxValues(slide1, slide2);

		this.minLabelEl.innerHTML = this.formatter.format(slide1);
		this.maxLabelEl.innerHTML = this.formatter.format(slide2);
	}

	onInput() {
		let slide1 = parseFloat(this.sliders[0].value);
		let slide2 = parseFloat(this.sliders[1].value);

		if (slide1 > slide2) {
			[slide1, slide2] = [slide2, slide1];
		}

		this.minLabelEl.innerHTML = this.formatter.format(slide1);
		this.maxLabelEl.innerHTML = this.formatter.format(slide2);
	}
}
customElements.define('range-slider', RangeSlider);
